import { useNgSession } from "./ng-session";

export function ngHandleMmi(): void {
    // do this only in case ng framework is ready and user is not logged in
    if (useNgSession().isLoggedIn.value) return;

    // check parameter from webpart
    if (typeof mmiParameter === "undefined") return;

    const mmi = parseInt(mmiParameter);
    if (isNaN(mmi)) return;

    // propagate parameter to NG
    ng_fw.setDefaultGameVerticalID(mmi);
}
